import { Pipe, PipeTransform } from '@angular/core';
import { MimeCategory } from '@common';

@Pipe({
  name: 'isFolder',
  pure: true,
  standalone: true
})
export class IsFolderPipe implements PipeTransform {
  transform(category: MimeCategory): boolean {
    return category === MimeCategory.Folder || category === MimeCategory.OneNoteFolder;
  }
}
